<template lang="html">
  <div >
    <div class="CSChatThai hidden-sm-and-down" style="height: calc(100vh - 37px); background-color: white;">
      <v-layout id="about" column wrap align-center>
      <v-flex xs12 sm4 class="my-2">
        <div class="text-xs-center">
          <h1 style="margin-top:7vw" class="display-2 CSChatThai">เกี่ยวกับ One Chat</h1>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card-title primary-title >
          <div class="CSChatThai" style="text-align: justify; margin-left: 120px; margin-right: 120px; text-align: justify; font-size: 20px;">&emsp;&emsp;&emsp;&emsp;<strong>One Chat</strong> เป็นแอปพลิเคชันหนึ่งในตระกูลของ <strong><a href="https://one.th/" target="_blank">One Platform</a></strong> ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้ ซึ่ง One Chat สามารถส่งข้อความ, ไฟล์, รูปภาพ และยังมีฟังก์ชันอื่น ๆ อีกมากมาย ปัจจุบันสามารถใช้ One Chat ได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS) ที่สำคัญ One Chat ยังเชื่อมต่อกับ <strong><a href="https://mail.one.th/" target="_blank">One E-mail</a></strong> ที่ให้บริการฟรีอีเมล, <strong><a href="https://box.one.th/login" target="_blank">One Box</a></strong> ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล และแอปพลิเคชันอื่น ๆ ในตระกูล One Platform อีกด้วย
          </div>
          </v-card-title>
          <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </div>
    <div class="CSChatThai hidden-md-and-up" style="background-color: white;">
      <v-layout id="aboutmo" column wrap align-center>
      <v-flex xs12 sm4 class="my-2">
        <div class="text-xs-center">
          <h1 style="margin-top:14vw;font-size:25px !important;" class="display-2">เกี่ยวกับ One Chat</h1>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card-title primary-title >
          <div class="headline CSChatThai" style="margin:10px !important; font-size:16px !important; text-align: justify;">&emsp;&emsp;&emsp;&emsp;<strong>One Chat</strong> เป็นแอปพลิเคชันหนึ่งในตระกูลของ <strong><a href="https://one.th/" target="_blank">One Platform</a></strong> ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล ซึ่งช่วยให้การขยายธุรกิจทำได้ง่ายและรวดเร็วขึ้น โดยอยู่ภายใต้มาตรฐานความปลอดภัยที่น่าเชื่อถือได้ ซึ่ง One Chat สามารถส่งข้อความ, ไฟล์, รูปภาพ และยังมีฟังก์ชันอื่น ๆ อีกมากมาย ปัจจุบันสามารถใช้ One Chat ได้บนทุกระบบปฏิบัติการของโทรศัพท์มือถือ ไม่ว่าจะเป็น iOS หรือ Android และบน PC (Windows, Mac OS) ที่สำคัญ One Chat ยังเชื่อมต่อกับ <strong><a href="https://mail.one.th/" target="_blank">One E-mail</a></strong> ที่ให้บริการฟรีอีเมล, <strong><a href="https://box.one.th/login" target="_blank">One Box</a></strong> ที่ให้บริการฟรีพื้นที่จัดเก็บไฟล์ข้อมูล และแอปพลิเคชันอื่น ๆ ในตระกูล One Platform อีกด้วย </div>
          </v-card-title>
          <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style type="text/css" scoped>
/*.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}*/
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
a:link {
  text-decoration: none !important;
}

a:visited {
  text-decoration: underline !important;
}

a:hover {
  color: black !important;
  text-decoration: underline !important;
}

a:active {
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Aboutus.vue